import React, { useState } from 'react';
import { Icon } from "semantic-ui-react";
import Cookies from "js-cookie";
import { useIntl } from "react-intl";

interface RegisterEmailSuccessProps {
  onHaveApiToken: () => void;
}

const DEFAULT_PROPS = {
  onHaveApiToken: () => {},
}
const RegisterEmailSuccess = (propsParam: RegisterEmailSuccessProps) => {

  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value])=> value !== undefined)),
  };

  React.useEffect(() => {
    if(Cookies.get("apiToken")){
       props.onHaveApiToken()
    }
  }, [Cookies.get("apiToken")])

  return (
    <div className="email-register-success">
    <div className="green">
      <Icon name="check" size="massive" />
    </div>
    <h1 className="green">
      Complete !
    </h1>
    <br/>
    <h4 className="sub-text">
      ท่านลงทะเบียนเพื่อขอเริ่มใช้งานสำเร็จแล้ว
      กรุณาตรวจสอบ E-mail เพื่อเริ่มใช้งาน
    </h4>
    </div>
  )
}


export default RegisterEmailSuccess
